import { QueryParams } from 'APIs/types';
import getFetchOptions from 'utils/getFetchOptions';

import { PaginatedResponse, handlePaginatedResponse, handleResponse, toQueryString } from '../utils';
import {
  MarketplaceGeneralSettingsResponse,
  MarketplaceGeneralSettingsUpdateRequest,
} from './marketplaces.general.settings.types';
import {
  CreateMarketplaceRequest,
  Marketplace,
  MarketplaceMerchantsQueryParams,
  MarketplaceSourceRulesetRequest,
  MarketplacesResponse,
  SetupBankTransfersRequest,
  StandardMarketplace,
} from './marketplaces.types';
import {
  MerchantMarketplaceSettingsResponse,
  MerchantMarketplaceSettingsUpdateRequest,
} from './merchant.marketplaces.settings.types';

export const getMarketplaces = async (
  apiBaseUri: string,
  queryParams: QueryParams,
): Promise<PaginatedResponse<MarketplacesResponse>> => {
  let qParams = toQueryString(queryParams, ['status']);
  const options = await getFetchOptions('GET');

  return await fetch(`${apiBaseUri}/admin/marketplaces${qParams}`, options).then(handlePaginatedResponse);
};

export const getMarketplace = async (apiBaseUri: string, marketplaceId: string): Promise<Marketplace> => {
  const options = await getFetchOptions();
  return await fetch(`${apiBaseUri}/admin/marketplaces/${marketplaceId}`, options).then(handleResponse);
};

export const getMarketplaceMerchants = async (
  apiBaseUri: string,
  marketplaceId: string,
  queryParams: MarketplaceMerchantsQueryParams,
): Promise<any> => {
  let qParams = toQueryString(queryParams, ['status', 'businessType']);
  const options = await getFetchOptions('GET');

  return await fetch(`${apiBaseUri}/platform/${marketplaceId}/dashboard/merchants${qParams}`, options).then(
    handleResponse,
  ); // Response contains the pagination data in the body
};

export const createMarketplace = async (
  apiAprilBaseUri: string,
  payload: CreateMarketplaceRequest,
): Promise<{ id: string; apiKey: string }> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/marketplaces`, options).then(handleResponse);
};

export const administerMarketplace = async (
  apiAprilBaseUri: string,
  payload: MarketplaceSourceRulesetRequest | SetupBankTransfersRequest,
): Promise<StandardMarketplace> => {
  const options = await getFetchOptions('PATCH', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/marketplaces`, options).then(handleResponse);
};

export const getMerchantMarketplaceSettings = async (
  apiBaseUri: string,
  marketplaceId: string,
  country: string,
): Promise<MerchantMarketplaceSettingsResponse> => {
  let qParams = toQueryString({ country });
  const options = await getFetchOptions('GET');

  return await fetch(`${apiBaseUri}/admin/marketplaces/${marketplaceId}/settings${qParams}`, options).then(
    handleResponse,
  );
};

export const updateMerchantMarketplaceSettings = async (
  apiBaseUri: string,
  marketplaceId: string,
  payload: MerchantMarketplaceSettingsUpdateRequest,
): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/admin/marketplaces/${marketplaceId}/settings`, options).then(handleResponse);
};

export const getMarketplaceGeneralSettings = async (
  apiBaseUri: string,
  marketplaceId: string,
): Promise<MarketplaceGeneralSettingsResponse> => {
  const options = await getFetchOptions('GET');

  return await fetch(`${apiBaseUri}/merchants/${marketplaceId}/settings/general`, options).then(handleResponse);
};

export const updateMarketplaceGeneralSettings = async (
  apiBaseUri: string,
  marketplaceId: string,
  payload: MarketplaceGeneralSettingsUpdateRequest,
): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/merchants/${marketplaceId}/settings/general`, options).then(handleResponse);
};
